export default __webpack_public_path__ + "static/media/placeholder.30c33746.svg";